import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Tooltip from '../../../../shared/Tooltip';
import { Wrapper } from '../../../../shared/ModalComponents';
import { Button } from '../../../../shared/FormStyles/Button';
import FollowUpDateInput from './FollowUpDateInput.jsx';
import useEditFollowUp from './useEditFollowUp';
import {
  StyledTitle,
  ButtonGroup,
  Label,
  Input,
  Information,
} from './StyledComponents';

const FormWrapper = styled.div`
  width: 100%;
  display: ${props => (props.hide ? 'none' : 'block')};
`;

const DateInput = styled(Input)`
  width: 100%;
`;

const LabelWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const CharactersLeft = styled.span`
  font-size: 9px;
  font-weight: 400;
  color: ${themeGet('colors.black.80')};
  align-self: center;
`;

const EditFollowUp = ({ followUp, onCancel }) => {
  const { t } = useTranslation('send');
  const maxCharacters = 80;

  const {
    values,
    handleSubmit,
    handleChange,
    setFieldValue,
  } = useEditFollowUp({ followUp });
  const [showCalendar, setShowCalendar] = useState(false);
  const [charactersLeft, setCharactersLeft] = useState(
    maxCharacters - values.subject.length,
  );

  const formatedDate = date => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    };

    return new Date(date).toLocaleDateString('en-US', options);
  };

  return (
    <Wrapper>
      <FormWrapper hide={showCalendar}>
        <StyledTitle>{t('followUp.editFollowUp')}</StyledTitle>
        <Tooltip />
        <LabelWrapper>
          <Label>
            {t('followUp.subjectLabel')}
            <Information
              className="fa-regular fa-circle-info fa-xs"
              size={13}
              data-tip={t('followUp.subjectTooltip')}
              data-offset="{ 'right': 130 }"
            />
          </Label>
          <CharactersLeft>
            {charactersLeft} {t('followUp.charactersLeft')}
          </CharactersLeft>
        </LabelWrapper>
        <Input
          id="follow_up_subject"
          type="text"
          name="subject"
          value={values.subject}
          onChange={e => {
            const textLength = e.target.value.length;
            if (textLength <= maxCharacters) {
              handleChange(e);
              setCharactersLeft(maxCharacters - textLength);
            }
          }}
        />
        <Label>{t('followUp.sendOnLabel')}</Label>
        <DateInput
          id="follow_up_send_on"
          value={formatedDate(values.sendOn)}
          onClick={() => setShowCalendar(true)}
          readOnly
        />
        <ButtonGroup>
          <Button variant="tertiary" onClick={onCancel}>
            {t('followUp.cancelButton')}
          </Button>
          <Button variant="containedBlue" ml="8px" onClick={handleSubmit}>
            {t('followUp.saveButton')}
          </Button>
        </ButtonGroup>
      </FormWrapper>
      {showCalendar && (
        <FollowUpDateInput
          value={values.sendOn}
          onCancel={() => setShowCalendar(false)}
          onConfirm={() => setShowCalendar(false)}
          handleChange={newDate => setFieldValue('sendOn', newDate[0])}
        />
      )}
    </Wrapper>
  );
};

export default EditFollowUp;
